<div class="modal-content-container">
    <span
      nz-icon
      nzType="left-circle"
      nzTheme="outline"
      class="icon left-arrow"
      *ngIf="showArrow && currentIndex !== 0 && listSize !== 0"
      (click)="toLeft()"
    ></span>
  <ng-content></ng-content>
  <span
    nz-icon
    nzType="right-circle"
    nzTheme="outline"
    class="icon right-arrow"
    *ngIf="showArrow && currentIndex !== listSize - 1 && listSize !== 0"
    (click)="toRight()"
  ></span>
</div>
